/* eslint-disable react/prop-types */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import PropTypes from 'prop-types';

export const propTypes = {
  children: PropTypes.node,
  // eslint-disable-next-line
  alignContent: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
    'stretch',
  ]),
  // eslint-disable-next-line
  alignItems: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  // eslint-disable-next-line
  display: PropTypes.oneOf(['flex', 'inline-flex']),
  // eslint-disable-next-line
  element: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  // eslint-disable-next-line
  flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  // eslint-disable-next-line
  flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  // eslint-disable-next-line
  justifyContent: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around',
  ]),

  wrappedComponentRef: PropTypes.func,
};

export default function Flex({
  element: Element,
  children,
  alignContent,
  alignItems,
  alignSelf,
  display,
  flexBasis,
  flexDirection,
  flexGrow,
  flexShrink,
  flexWrap,
  justifyContent,
  order,
  wrappedComponentRef,
  ...props
}) {
  return (
    <Element
      {...props}
      css={css({
        alignContent,
        alignItems,
        alignSelf,
        display,
        flexBasis,
        flexDirection,
        flexGrow,
        flexShrink,
        flexWrap,
        justifyContent,
        order,
      })}
      ref={wrappedComponentRef}
    >
      {children}
    </Element>
  );
}

Flex.propTypes = propTypes;

Flex.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'stretch',
  children: null,
  display: 'flex',
  element: 'div',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  justifyContent: 'flex-start',
  wrappedComponentRef() {},
};
